//@ts-expect-error no type definition for baselines
import { rollingAverageBaseline as baselineFct } from 'baselines';
/**
 * @param data
 */
export function rollingAverageBaseline(data) {
    data.y = baselineFct(data.y).correctedSpectrum;
    return { data };
}
//# sourceMappingURL=rollingAverageBaseline.js.map